export enum FormActions {
  REMOVE = 'remove',
  ADD = 'add',
  UPDATE = 'update',
  UPSERT = 'upsert',
  LOADING = 'loading',
}

export enum ApiStatuses {
  SUCCESS = 'success',
  ERROR = 'error',
  LOADING = 'loading',
  INFO = 'info',
  WARNING = 'warning',
}
